import SetupStep from './SetupStep';

function StepConfigure() {
  return (
    <SetupStep
      id="step-configure"
      index="02"
      kicker="CONFIGURE"
      title="Attach The EA & Apply Your Settings."
      intro="The EA operates on a chart. You attach it to XAUUSD, allow algorithmic trading, and apply the settings that come with your delivery."
      panelLabel="CONFIGURE CHECKLIST"
      note="These settings are the inputs exposed by the EA. This page does not list specific parameter values — apply the configuration supplied with your EA."
      tone="muted"
      reverse
      points={[
        {
          title: 'Open the XAUUSD chart',
          detail:
            'Open a chart for the XAUUSD symbol in Market Watch so the EA has the market it is designed for.',
        },
        {
          title: 'Attach the EA',
          detail:
            'Drag the EA from the Navigator onto the chart, or double-click it, to open its settings dialog.',
        },
        {
          title: 'Allow algorithmic trading',
          detail:
            'In the EA dialog, enable the option that allows the EA to trade so it is permitted to act on the chart.',
        },
        {
          title: 'Apply your inputs',
          detail:
            'Configure the inputs the EA exposes using the settings provided with your delivery, following any accompanying guidance.',
        },
        {
          title: 'Save a preset (optional)',
          detail:
            'Save your configured inputs as a preset so you can reload the same settings on other charts or later sessions.',
        },
      ]}
    />
  );
}

export default StepConfigure;